import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LandlordSidebar from '../components/LandlordDashboard/LandlordSidebar';
import BuildingManagement from '../components/BuildingMgmt/BuildingManagement';
import UnitApplicationManagement from '../components/BuildingMgmt/UnitApplicationManagement';
import RoleToggleFeedback from '../components/common/RoleToggleFeedback';
import styles from '../styles/Landlord/LandlordDashboardPage.module.css';

const BuildingManagementPage = () => {
  const { buildingId } = useParams();
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [role, setRole] = useState('Landlord');
  const navigate = useNavigate();

  const handleSelectUnit = (unit) => {
    setSelectedUnit(unit);
  };

  const handleCloseApplications = () => {
    setSelectedUnit(null);
  };
  
  const handleFeedback = () => {
    window.open('mailto:ACodding@mba2025.hbs.edu?subject=Bug Report / Feedback', '_blank');
  };
  
  const handleRoleChange = (newRole) => {
    setRole(newRole);
    if (newRole === 'Tenant') navigate('/profile');
  };

  return (
    <div className={styles.landlordDashboard}>
      <LandlordSidebar activeTab="properties" setActiveTab={() => {}} />
      <div className={styles.mainContent}> 
        <RoleToggleFeedback 
          role={role} 
          onRoleChange={handleRoleChange}
          onFeedback={handleFeedback}
        />
        {!selectedUnit ? (
          <BuildingManagement 
            buildingId={buildingId} 
            onSelectUnit={handleSelectUnit} 
          />
        ) : (
          <UnitApplicationManagement
            unit={selectedUnit}
            handleBack={handleCloseApplications}
          />
        )}
      </div>
    </div>
  );
};

export default BuildingManagementPage;
